import Button from 'react-bootstrap/Button'
import { FaCheck, FaPen } from 'react-icons/fa'
import { GrClose } from 'react-icons/gr'
import { ReactComponent as PictoHeart } from 'assets/default/svg/picto_heart.svg'
import cn from 'classnames'
import Spinner from 'react-bootstrap/Spinner'
import s from './ButtonIcon.module.scss'

type IconType = 'edit' | 'submit' | 'heart' | 'cross'

interface Props {
  icon?: IconType
  size?: 'xs' | 'md'
  type?: 'button' | 'submit'
  className?: string
  loading?: boolean
  active?: boolean
  disabled?: boolean
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void
}

const defaultProps = {
  icon: 'edit',
  size: 'md',
  type: 'button',
  className: undefined,
  loading: false,
  active: false,
  disabled: false,
  onClick: () => null,
}

const Icon = {
  edit: <FaPen />,
  submit: <FaCheck />,
  heart: <PictoHeart />,
  cross: <GrClose />,
}

const ButtonIcon = ({
  icon = defaultProps.icon as IconType,
  size = 'md',
  type,
  className,
  loading,
  active,
  disabled,
  onClick,
}: Props): JSX.Element => (
  <Button
    data-testid="button-icon"
    variant="none"
    className={cn(s.buttonIcon, s[icon], s[size], className, {
      [s.active]: active,
    })}
    type={type}
    onClick={onClick}
    disabled={disabled}
  >
    {loading ? (
      <Spinner
        data-testid="spinner"
        className={cn(s.spinner, { [s.active]: active })}
        animation="border"
      />
    ) : (
      Icon[icon]
    )}
  </Button>
)
ButtonIcon.defaultProps = defaultProps
export default ButtonIcon
